module.exports = __webpack_public_path__ + "img/fruit-cranberries-190x100.a9604ac4.jpg";